<template>
    <div class="statistics-container">
        <div class="cards-container">
            <ul class="card box">
                <li class="item" v-for="(value, key) in leftCount" :key="key">
                    <p class="card-title">{{value}}</p>
                    <p class="card-count">{{ taskNumData[key] || 0 }}</p>
                </li>
            </ul>
        </div>

        <div class="box chart-box">
            <div class="head">
                <div class="text">历史任务统计</div>
                <div class="time-select-tab" :class="{ active: taskPieCountActive === 7 }" @click="statsByDayTaskNum(7)">7日</div>
                <div class="time-select-tab" :class="{ active: taskPieCountActive === 30 }" @click="statsByDayTaskNum(30)">30日</div>
            </div>
            <a-row style="margin-bottom: 15px;">
                <a-col :span="8">
                    <div id="barDataCountChart"></div>
                </a-col>
                <a-col :span="16">
                    <div id="lineDataCountChart" style="margin-top: 10px"></div>
                </a-col>
            </a-row>
        </div>

        <div class="box chart-box">
            <div class="head">
                <div class="text">历史采集统计</div>
                <div class="time-select-tab" :class="{ active: historyCollectionActive === 7 }" @click="getParseStatsDetailBySpiderId(7)">7日</div>
                <div class="time-select-tab" :class="{ active: historyCollectionActive === 30 }" @click="getParseStatsDetailBySpiderId(30)">30日</div>
            </div>
            <a-row style="margin-bottom: 15px;">
                <a-col :span="8">
                    <div id="addPieChart"></div>
                </a-col>
                <a-col :span="16">
                    <div id="dutyStatusBarChart" style="margin-top: 10px"></div>
                </a-col>
            </a-row>
        </div>
    </div>
</template>

<script>
  import {
    getResulNumtById,
    getTaskNumById,
    parseStatsDetailBySpiderId,
    statsByDayTaskNum
  } from '@/api/Site/Info'

  export default {
    data() {
      return {
        leftCount: {
          totalTaskNum: '任务数总数',
          totalSuccessTaskNum: '成功任务数',
          totalResultNum: '采集总数',
          totalSuccessResultNum: '采集成功数'
        },
        spiderStat: {},
        spiderStat30: {},
        timeDuration: 30,

        taskPieCountActive: 7,
        historyCollectionActive: 7,
        addResultActive: 7,

        pieData: [],
        taskNumData: {}
      }
    },
    mounted() {
      this.getTaskNumById()
      this.getResulNumtById()

      this.getParseStatsDetailBySpiderId(7) // 历史采集
      this.statsByDayTaskNum(7) // 历史任务
    },

    methods: {
      //顶部统计分析任务数
      async getTaskNumById() {
        const { code, extra } = await getTaskNumById({ spiderId: this.$route.query.spiderId })
        if (code === 200) {
          this.taskNumData = Object.assign({}, this.taskNumData, extra.data)
        }
      },
      //顶部统计结果任务数
      async getResulNumtById() {
        const { code, extra } = await getResulNumtById({ spiderId: this.$route.query.spiderId })
        if (code === 200) {
          this.taskNumData = Object.assign({}, this.taskNumData, extra.data)
        }
      },

      //历史任务统计
      async statsByDayTaskNum(day = 7) {
        this.taskPieCountActive = day
        const { code, extra } = await statsByDayTaskNum({ spiderId: this.$route.query.spiderId, day })
        if (code === 200) {
          this.$nextTick(() => {
            this.initPieDataCountChart(
              [
                {value: extra.data.statsTotal.startStatusTaskNum, name: '待执行'},
                {value:extra.data.statsTotal.executeTaskNum, name: '执行中'},
                {value:extra.data.statsTotal.successTaskNum, name: '成功'},
                {value:extra.data.statsTotal.failTaskNum, name: '失败'},
                // {name:extra.data.statsTotal.startStatusTaskNum, value: '暂停'},
              ],
              extra.data.statsTotal.totalTaskNum
            )
            this.initLineDataCountChart(extra.data.statsDetail)
          })
        }
      },

      // 历史采集
      async getParseStatsDetailBySpiderId(day = 7) {
        this.historyCollectionActive = day
        const { code, extra } = await parseStatsDetailBySpiderId({ spiderId: this.$route.query.spiderId, day })
        if (code === 200) {
          this.$nextTick(() => {
            this.initAddPieChart([
              {name: '采集成功',value: extra.totalSuccessResultNum},
              {name: '采集失败',value: extra.totalFailResultNum},
            ], extra.totalResultNum)

            this.initDutyStatusBarChart(extra.data)
          })
        }
      },
      // 历史采集左边饼图
      initAddPieChart(data, count) {
        this.addPieChart = this.$echarts.init(document.getElementById('addPieChart'))
        this.addPieChart.setOption({
          tooltip: { trigger: 'item' },
          legend: {
            orient: 'vertical',
            right: 30,
            top: 110,
            bottom: 20,
            itemWidth: 12,
            itemHeight: 12,
            itemGap: 20,
            formatter: function(params) {
              return params
            }
          },
          title: {
            text: '采集总数',
            textAlign: 'center',
            left: '39%',
            top: '43%',
            subtext: String(count),
            subtextStyle: {
              fontSize: 20,
              color: '#333'
            }
          },
          series: [
            {
              type: 'pie',
              center: ['40%', '50%'],
              radius: ['50%', '70%'],
              color: ['rgb(84,112,198)', 'rgb(145,203,116)', 'rgb(250,200,88)', 'rgb(238,102,102)'],
              itemStyle: {
                borderRadius: 10,
                borderColor: '#fff',
                borderWidth: 2
              },
              label: { show: false },
              data: data
            }
          ]
        })
        window.addEventListener('resize', () => {
          this.addPieChart.resize()
        })
      },
      // 历史采集柱状图
      initDutyStatusBarChart(data) {
        this.dutyStatusBarChart = this.$echarts.init(document.getElementById('dutyStatusBarChart'))
        this.dutyStatusBarChart.setOption({
          tooltip: { trigger: 'axis' },
          grid: {
            right: '1%',
            top: '13%',
            left: '6%',
            bottom: '20%'
          },
          legend: {},
          xAxis: {
            type: 'category',
            axisLine: {
              show: true,
              lineStyle: {
                color: '#E2E2E2',
                width: 2
              }
            },
            axisTick: { show: false },
            axisLabel: { color: '#666666', margin: 20 },
            splitLine: { color: '#EBEBEB', width: 1 },
            data: Object.keys(data)
          },
          yAxis: {
            type: 'value',
            axisLine: { show: false },
            axisLabel: { margin: 20 },
            axisTick: { show: false }
          },
          series: [
            {
              name: '成功结果数',
              type: 'bar',
              stack: 'one',
              barWidth: 30,
              color: '#4683FF',
              data: (Object.values(data)).map(item => item.successResultNum)
            },
            {
              name: '失败结果数',
              type: 'bar',
              barWidth: 30,
              stack: 'one',
              color: '#3DD598',
              data: (Object.values(data)).map(item => item.failResultNum)
            }
          ]
        })
        window.addEventListener('resize', () => {
          this.dutyStatusBarChart.resize()
        })
      },

      // 历史任务统计柱图
      initLineDataCountChart(data) {
        this.lineDataCountChart = this.$echarts.init(document.getElementById('lineDataCountChart'))
        this.lineDataCountChart.setOption({
          tooltip: { trigger: 'axis' },
          grid: {
            right: '1%',
            top: '13%',
            left: '5%',
            bottom: '20%'
          },
          legend: {},
          xAxis: {
            type: 'category',
            axisLine: {
              show: true,
              lineStyle: {
                color: '#E2E2E2',
                width: 2
              }
            },
            axisTick: { show: false },
            axisLabel: { color: '#666666', margin: 20 },
            splitLine: { color: '#EBEBEB', width: 1 },
            data: Object.keys(data)
          },
          yAxis: {
            type: 'value',
            axisLine: { show: false },
            axisLabel: { margin: 20 },
            axisTick: { show: false }
          },

          series: [
            {
              name: '成功任务数',
              type: 'bar',
              barWidth: 30,
              stack: 'one',
              color: '#4683FF',
              data: (Object.values(data)).map(item => item.successTaskNum)
            },
            {
              name: '失败任务数',
              type: 'bar',
              barWidth: 30,
              stack: 'one',
              color: '#3DD598',
              data: (Object.values(data)).map(item => item.failTaskNum)
            }
          ]
        })
        window.addEventListener('resize', () => {
          this.lineDataCountChart.resize()
        })
      },
      // 历史任务统计饼图
      initPieDataCountChart(data, count) {
        this.barDataCountChart = this.$echarts.init(document.getElementById('barDataCountChart'))
        this.barDataCountChart.setOption({
          tooltip: { trigger: 'item' },
          legend: {
            orient: 'vertical',
            right: 30,
            top: 80,
            bottom: 20,
            itemGap: 20,
            itemWidth: 12,
            itemHeight: 12,
            formatter: function(params) {
              return params
            }
          },
          title: {
            text: '总任务数',
            textAlign: 'center',
            left: '39%',
            top: '43%',
            subtext: String(count),
            subtextStyle: {
              fontSize: 20,
              color: '#333'
            }
          },
          series: [
            {
              type: 'pie',
              center: ['40%', '50%'],
              radius: ['50%', '70%'],
              color: ['rgb(84,112,198)', 'rgb(145,203,116)', 'rgb(250,200,88)', 'rgb(238,102,102)'],
              itemStyle: {
                borderRadius: 10,
                borderColor: '#fff',
                borderWidth: 2
              },
              label: { show: false },
              data: data
            }
          ]
        })
        window.addEventListener('resize', () => {
          this.barDataCountChart.resize()
        })
      },
    }
  }
</script>


<style lang="less" scoped>
    .statistics-container {
        .box {
            background: #fff;
            border-radius: 4px;
        }

        .cards-container {
            .card{
                display: flex;
                justify-content: space-between;
                padding: 25px 0;
            }

            .item:last-child{
                border: none;
            }
            .item {
                flex: 1;
                text-align: center;
                border-right: 1px solid #E2E2E2;

                .card-title {
                    font-size: 14px;
                    color: #999;
                }

                .card-count {
                    font-size: 36px;
                    font-weight: bold;
                    color: #333333;
                    margin-bottom: 0;
                }
            }
        }

        .head {
            height: 55px;
            border-bottom: 1px solid #e9e9e9;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .text {
                font-size: 18px;
                font-weight: 600;
                margin-right: auto;
            }

            .time-select-tab {
                font-size: 14px;
                cursor: pointer;
                width: 82px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                background: #F5F6FA;
                border-radius: 4px;
                margin-left: 10px;

                &.active {
                    color: #fff;
                    background: #4683FF;
                }
            }
        }

        .chart-box {
            padding: 0 20px;

            #lineDataCountChart, #barDataCountChart, #addPieChart, #dutyStatusBarChart {
                height: 310px;
            }
        }
    }
</style>
